<div class="flex h-[520px]">
  <!-- Left Panel - Groups (pages) -->
  <div class="w-56 border-r border-surface-200 dark:border-surface-700 overflow-y-auto">
    @if (isLoading$ | async) {
      <div class="flex flex-col gap-2 p-3">
        <p-skeleton height="2rem"/>
        <p-skeleton height="2rem"/>
        <p-skeleton height="2rem"/>
      </div>
    } @else if ((groups$ | async)?.length) {
      @for (group of groups$ | async; track group.id) {
        <div
          (click)="selectGroup(group.id)"
          [ngClass]="{
            'bg-surface-100 dark:bg-surface-800 text-primary-700 dark:text-primary-300 font-semibold': selectedGroupId() === group.id,
            'hover:bg-surface-50 dark:hover:bg-surface-800/60 text-surface-700 dark:text-surface-300': selectedGroupId() !== group.id
          }"
          class="px-4 py-2 cursor-pointer transition-colors text-sm"
        >
          {{ groupLabel(group) }}
        </div>
      }
    } @else {
      <div class="p-4 text-surface-500 dark:text-surface-400 text-sm">
        Keine Einstellungen verfügbar.
      </div>
    }
  </div>

  <!-- Right Panel - Form of selected group -->
  <div class="flex-1 flex flex-col min-h-0">
    <div class="flex-1 overflow-y-auto p-6">
      @if (isLoading$ | async) {
        <div class="flex flex-col gap-3">
          <p-skeleton height="2.5rem"/>
          <p-skeleton height="2.5rem"/>
          <p-skeleton height="2.5rem"/>
        </div>
      } @else {
        @if (formFields$ | async; as formFields) {
          <zaeper-form-builder (onChange)="handleOnChange($event)" [inputElement]="formFields"/>
        } @else {
          <div class="text-surface-500 dark:text-surface-400 text-sm">
            Wählen Sie links eine Seite aus, um deren Einstellungen anzuzeigen.
          </div>
        }
      }
    </div>

    @if (!(isLoading$ | async) && (groups$ | async)?.length) {
      <div class="border-t border-surface-200 dark:border-surface-700 px-6 py-4 flex justify-end">
        <p-button [rounded]="true" [loading]="(isSaving$ | async) ?? false" (onClick)="handleSave()">Speichern</p-button>
      </div>
    }
  </div>
</div>
